const Container = () => import('./../views/Container');

const ClientPageDetails = () => import('./../views/ClientPageDetails');
const ClientPageList = () => import('./../views/ClientPageList');

export default [
  {
    path: '/clientes',
    component: Container,
    meta: { requiresAuth: true, permissions: ['view_clients'] },
    children: [
      {
        path: '',
        name: 'client-list',
        component: ClientPageList
      },
      {
        path: ':id/',
        name: 'client-details',
        component: ClientPageDetails
      }
    ]
  }
];
